import {Component, OnInit, ViewChild} from '@angular/core';
import {AppState, selectAuthState} from '../../../store/app.states';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {QuestionnaireNotRead} from '../../../model/questionnaires/questionnaire-not-read';
import {DoctorService} from '../../../services/doctor.service';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {DialogService} from '../../../services/dialog.service';
// @ts-ignore
import { default as _rollupMoment } from 'moment';
import * as _moment from 'moment';
import {BackendApi, localhost} from '../../../config/backend-api';
import {HttpClient} from '@angular/common/http';
import {Patient} from '../../../model/user/Patient';
import {FormControl} from '@angular/forms';
import {ErrorDialogComponent} from '../../user-actions/error-dialog/error-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
const moment = _rollupMoment || _moment;


@Component({
  selector: 'app-questionnaires-summary',
  templateUrl: './questionnaires-summary.component.html',
  styleUrls: ['./questionnaires-summary.component.css']
})
export class QuestionnairesSummaryComponent implements OnInit {

  getAuthState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  destination = 'patients-control-panel';
  title = 'Questionari da visionare';
  questionnairesNotRead: QuestionnaireNotRead[];
  displayedColumns: string[] = ['select', 'namePatient', 'surnamePatient', 'finalScore', 'type', 'date'];
  dataSource = new MatTableDataSource<QuestionnaireNotRead>();
  selection = new SelectionModel<QuestionnaireNotRead>(true, []);
  notReady = false; // permette la visualizzazione della barra di caricamento nella tabella.
  typesControl = new FormControl(false);
  typesList: string[] = ['NESSUNO', 'HBI', 'IBD-DISK', 'MIAH-CD', 'MIAH-UC', 'PATIENT-SCCAI', 'IPAQ-SF',
                          'PHQ9', 'WPAI', 'MMAS8', 'TSQM', 'PRISM', 'EQ5D5L', 'PSQI', 'IBDQ',
                          'CLINICAL-HBI', 'CLINICAL-PRISM', 'CLINICAL-SCCAI','LARS'];
  toShow = null; // copiato dalla funzionalità già presente in patient-questionnaires-show
 // patient: Patient; // copiato dalla funzionalità già presente in patient-questionnaires-show
  filterName: string;
  filterType: string;

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;


  constructor(private store: Store<AppState>,
              private doctorService: DoctorService,
              private dialogService: DialogService,
              public dialog: MatDialog,
              private httpClient: HttpClient,
              private snackBar: MatSnackBar) {
    this.getAuthState = this.store.select(selectAuthState);
  }

  ngOnInit(): void {
    this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;

      // Si fa la richiesta per i questionari non letti per creare la tabella
      if (this.questionnairesNotRead === [] || this.questionnairesNotRead === undefined || this.questionnairesNotRead === null) {
        this.notReady = true;
        this.doctorService.getQuestionnaireNotRead().subscribe(
          questionnaires => {
            this.updateTable(questionnaires);
            if (this.questionnairesNotRead !== [] && this.questionnairesNotRead != null) {
              this.notReady = false;
            }
          });
      }
    });
  }

  /** Utilizzata per la visualizzazione della master checkbox con la spunta che indica che tutte le righe sono selezionate */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Pulisce/Seleziona tutte le checkbox delle singole righe. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  /** Permette la visualizzazione di un singolo questionario */
  showQuestionnaire(questionnaire) {
    // quasi tutto copiato dalla funzionalità già presente in patient-questionnaires-show
    this.doctorService.getQuestionnaire(questionnaire.id, questionnaire.type).subscribe(
      r => {
        this.doctorService.getPatient(r.patientSSN).subscribe(patient => {
            console.log(r);
            switch (questionnaire.type.toLowerCase()) {
              case 'clinical-sccai':
                this.setRead(r);
                this.dialogService.openClinicalSCCAIDialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
              case 'clinical-hbi':
                this.setRead(r);
                this.dialogService.openHBIDialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
              case 'clinical-prism':
                this.setRead(r);
                this.dialogService.openPRISMDialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
              case 'eortc-qlq':
                this.setRead(r);
                this.dialogService.openEORTCDialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
              case 'eq5d5l':
                this.setRead(r);
                this.dialogService.openEQ5D5LDialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
              case 'hads':
                this.setRead(r);
                this.dialogService.openHADSDialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
              case 'hbi':
                this.setRead(r);
                this.dialogService.openHBIDialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
              case 'ibd-disk':
                this.setRead(r);
                this.dialogService.openIBDDiskDialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
              case 'ipaq-sf':
                this.setRead(r);
                this.dialogService.openIPAQSFDialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
              case 'miah-cd':
                this.setRead(r);
                this.dialogService.openMIAHCDDialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
              case 'miah-uc':
                this.setRead(r);
                this.dialogService.openMIAHUCDialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
              case 'mmas8':
                this.setRead(r);
                this.dialogService.openMMAS8Dialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
              case 'patient-sccai':
                this.setRead(r);
                this.dialogService.openPatientSCCAIDialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
              case 'phq9':
                this.setRead(r);
                this.dialogService.openPHQ9Dialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
              case 'prism':
                this.setRead(r);
                this.dialogService.openPRISMDialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
              case 'psqi':
                this.setRead(r);
                this.dialogService.openPSQIDialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
              case 'sibdq':
                this.setRead(r);
                this.dialogService.openSIBDQDialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
              case 'tsqm':
                this.setRead(r);
                this.dialogService.openTSQMDialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
              case 'wpai':
                this.setRead(r);
                this.dialogService.openWPAIDialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;
                // IBDQ
              case 'ibdq':
                this.setRead(r);
                this.dialogService.openIBDQDialog(r, this.user.role, patient).afterClosed()
                  .subscribe(action => {
                    setTimeout(() => {
                      this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                      if (this.toShow !== null) {
                        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                        this.dataSource = new MatTableDataSource(this.toShow);
                      }
                    }, 500);
                  });
                break;

                case 'lars':
                  this.setRead(r);
                  this.dialogService.openLARSDialog(r, this.user.role, patient).afterClosed()
                    .subscribe(action => {
                      setTimeout(() => {
                        this.toShow = JSON.parse(localStorage.getItem(questionnaire.type));
                        if (this.toShow !== null) {
                          this.toShow.sort((r1, r2) => this.comparing(r1, r2));
                          this.dataSource = new MatTableDataSource(this.toShow);
                        }
                      }, 500);
                    });
                  break;

              default:
                break;
            }
          }
        );
      });
  }

  /** Filtro in base al nome e cognome del paziente */
  applyFilter(event: Event) {
    // Inizialmente filtro i questionari non letti per il nome e il cognome
    this.filterName = (event.target as HTMLInputElement).value;
    this.dataSource.data = this._filter(this.filterName);
    // successivamente controllo se su questi questionari non letti devo applicare anche il filtro sul type, che
    // sarà indicato in this.filterType
    if (this.filterType === 'NESSUNO' || this.filterType === null || this.filterType === undefined ) {
      return;
    }
    this.dataSource.data = this.dataSource.data.filter(option => ((option.type).toLowerCase() === (this.filterType.toLowerCase())));
  }

  /** Filtro in base al tipo di questionario */
  applyFilterType(value: any) {
    // Inizialmente filtro i questionari non letti per il nome e il cognome
    if (this.filterName != null) {
      this.dataSource.data = this._filter(this.filterName);
    } else {
      this.dataSource.data = this.questionnairesNotRead;
    }
    // successivamente applico il filtro in base al tipo di questionario
    this.filterType = value;
    if (this.filterType === 'NESSUNO') {
      return;
    }
    this.dataSource.data = this.dataSource.data.filter(option => ((option.type).toLowerCase() === (value.toLowerCase())));
  }

  /** Metodo che permette il filtro sul nome e cognome */
  private _filter(value: string): QuestionnaireNotRead[] {
    let filterValues: string[];
    const filterValue = value.toLowerCase();
    filterValues = filterValue.split(' ');
    /* Cancellato perché potrebbero esserci pazienti con due nomi o cognomi composti da due parole
       In questi casi il filtro non è perfetto.
    if (filterValues.length > 2) {
      return [];
    }*/
    if (filterValues.length === 1) {
      // tslint:disable-next-line:max-line-length
      return this.questionnairesNotRead.filter(option => (option.namePatient).toLowerCase().includes(filterValues[0]) || option.surnamePatient.toLowerCase().includes(filterValues[0]));
    }
    if (filterValues.length === 2) {
      return this.questionnairesNotRead.filter(option => ((option.namePatient).toLowerCase().includes(filterValues[1]) && option.surnamePatient.toLowerCase().includes(filterValues[0]))
        || ((option.surnamePatient).toLowerCase().includes(filterValues[1]) && option.namePatient.toLowerCase().includes(filterValues[0])));
    }
  }


  comparing(r1, r2) { // copiato dalla funzionalità già presente in patient-questionnaires-show
    const first = r1.id.split(' ');
    const second = r2.id.split(' ');
    const d1 = moment(first[0], 'DD/MM/YYYY').toDate().getTime();
    const d2 = moment(second[0], 'DD/MM/YYYY').toDate().getTime();
    return d1 < d2 ? 1 : (d1 > d2 ? -1 : 0);
  }

  setRead(r) { // copiato dalla funzionalità già presente in patient-questionnaires-show

    this.questionnairesNotRead = this.questionnairesNotRead.filter(questionnaire => (questionnaire.id) !== (r.id));
    this.updateTable(this.questionnairesNotRead);

    const date = r.id.split('-')[0];
    if (!r.read) {
      // tslint:disable-next-line:max-line-length
      return this.httpClient.post(localhost + BackendApi.READ_QUESTIONNAIRE + r.type + '/' + r.doctorID + '/' + r.patientSSN, date, {
        observe: 'response',
        responseType: 'text'
      }).subscribe(action => {
        console.log('letto', action);
      });
    }
  }

  /** Metodo che permette l'aggiornamento della tabella ogni volta che vengono fatti filtri o aggiornamenti */
  updateTable(questionnaires: QuestionnaireNotRead[]) {
    this.questionnairesNotRead = questionnaires;
    this.dataSource = new MatTableDataSource<QuestionnaireNotRead>(this.questionnairesNotRead);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
      if (typeof data[sortHeaderId] === 'string') {
        return data[sortHeaderId].toLocaleLowerCase();
      }
      return data[sortHeaderId];
    };
    this.dataSource.sort = this.sort;
  }

  /** Metodo che prende i questionari selezionati con le check box e li segna come letti. Attivato tramite un bottone */
  markAsReadQuestionnaires() {
    const listQuestionnaires = this.selection['_selected'].map(q => q.id);
   // console.log(listQuestionnaires);
    this.doctorService.markAsReadQuestionnaires(listQuestionnaires).subscribe(response => {
      console.log(response);
      if (response.status === 200) {
          // si rimuovono i questionari segnati come letti e si manda un messaggio di operazione riuscita tramite una piccola snackbar.
          this.questionnairesNotRead = this.questionnairesNotRead.filter(questionnaire => !listQuestionnaires.includes((questionnaire.id)));
          this.updateTable(this.questionnairesNotRead);
          this.selection.clear();
          this.openSnackBar('Operazione eseguita con successo', 'Chiudi');
      }
      },
      error => {
        const msg = 'C\'è stato un errore. Riprovi più tardi e se il problema persiste contattaci via e-mail';
        this.openDialog(msg);
        // this.router.navigateByUrl('/error').then(() => setTimeout(() => location.replace('/startup'), 1500));
        // console.log(error);
      });
  }

  openDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }
}
